<template>
  <ui-loading
    class="fl-layout-loading"
    :is-open="hasLoading"
    size="big"
    type="global"
  />
</template>

<script>
import UiLoading from "@iflat-ui/components/loader/UiLoading.vue";

import {useLayoutStore} from "@/store/layout";

export default {
  components: {UiLoading},
  data() {
    return {
      layoutStore: useLayoutStore()
    }
  },
  computed: {
    hasLoading() {
      return this.layoutStore.hasLoading
    }
  },
}
</script>

<style lang="scss" scoped>
.fl-layout-loading {
  background-color: $white;
}
</style>
